export const COMMON_SERVICE = 'COMMON_SERVICE';
export const DEALER_SERVICE = 'DEALER_SERVICE';
export const ORDER_SERVICE = 'ORDER_SERVICE';
export const STORE_SERVICE = 'STORE_SERVICE';
export const MY_EQUIPMENT_SERVICE = 'MY_EQUIPMENT_SERVICE';
